module.exports = __webpack_public_path__ + "static/other/gameUniformDesignSleb.a0a93b9d.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameUniformDesignSleb.json
// module id = 2544
// module chunks = 0